import { gql } from '@apollo/client';
import { AssemblyTestStatus } from '../../types/backflowAssembly';
import { TestResult } from '../../types/backflowTest';

export const GET_ASSEMBLY_IDS = gql`
  query GetAssemblyIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
    $includeAddress: Boolean = false
  ) {
    backflowAssemblies(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
      address @include(if: $includeAddress) {
        latitude
        longitude
      }
    }
  }
`;

export const GET_ASSEMBLIES_WATER_SUPPLIER = gql`
  query GetAssemblies(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowAssemblies(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      customerName
      model {
        name
        backflowAssemblyMake {
          name
        }
      }
      size
      type
      testStatus
      scheduledCompany
      compliant
      compliantReason
      lastTest {
        jobId
        initialResult
        finalResult
      }
      serialNumber
      location
      hazardType
      hazardLevel
      protectionType
      testAnniversary
      lastTestDate
      nextTestDate
      installDate
      address(required: true) {
        street1
        street2
        city
        state
        zip
        zipExt
      }
      waterService(required: true) {
        id
        type
        status
        siteNumber
        meterNumber
        radioId
        pin
      }
      tags
    }
  }
`;

export const GET_ASSEMBLIES_COMPANY = gql`
  query GetAssemblies(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowAssemblies(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      customerName
      model {
        name
        backflowAssemblyMake {
          name
        }
      }
      size
      type
      waterSupplier {
        profileId
        profile {
          id
          name
        }
      }
      testStatus
      compliant
      compliantReason
      serialNumber
      location
      hazardType
      hazardLevel
      protectionType
      testAnniversary
      lastTestDate
      nextTestDate
      installDate
      address(required: true) {
        street1
        street2
        city
        state
        zip
        zipExt
      }
      waterService {
        id
        meterNumber
        pin
      }
      tags
    }
  }
`;

export type AssemblyItem = {
  id: string;
  customerName?: string;
  customerStatus?: string;
  model: {
    name: string;
    backflowAssemblyMake: {
      name: string;
    };
  };
  size: number;
  type: string;
  serialNumber: string;
  location: string;
  testAnniversary: string;
  testStatus: AssemblyTestStatus;
  scheduledCompany?: string;
  hazardType: string;
  hazardLevel?: 'HIGH' | 'LOW';
  protectionType?: 'SERVICE' | 'INTERNAL';
  compliant: boolean;
  compliantReason: string;
  lastTestDate: string;
  lastTest?: {
    initialResult?: TestResult;
    finalResult?: TestResult;
  };
  nextTestDate: string;
  address: {
    street1: string;
    street2?: string;
    city: string;
    state: string;
    zip: string;
    zipExt?: string;
  };
  waterService: {
    type: string;
    status: string;
    siteNumber: string;
    meterNumber: string;
    radioId: string;
    pin: string;
  };
  tags: string[];
  installDate?: string;
};
